import React from 'react';
import { Badge } from './Badge.js';

interface SectionHeaderProps {
  tag?: string;
  tagVariant?: 'emerald' | 'cyan' | 'indigo' | 'amber';
  title: string;
  description?: string;
  align?: 'center' | 'left';
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  tag,
  tagVariant = 'emerald',
  title,
  description,
  align = 'center',
}) => {
  return (
    <div className={`mb-12 md:mb-16 ${align === 'center' ? 'text-center mx-auto max-w-3xl' : 'max-w-2xl'}`}>
      {tag && (
        <div className={`mb-4 flex ${align === 'center' ? 'justify-center' : 'justify-start'}`}>
          <Badge variant={tagVariant}>{tag}</Badge>
        </div>
      )}
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 mb-4 leading-tight">
        {title}
      </h2>
      {description && (
        <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
};
